import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Reveal } from './Reveal';
import { CountUp } from './CountUp';
const stages: {
  label: string;
  value: number;
  fill: number;
}[] = [{
  label: 'Answered instantly',
  value: 118,
  fill: 100
}, {
  label: 'Qualified',
  value: 61,
  fill: 52
}, {
  label: 'Booked',
  value: 24,
  fill: 20
}];
export function FunnelStrip() {
  const reduceMotion = useReducedMotion();
  return <div className="rounded-xl border border-white/10 bg-ink-700 p-6 sm:p-7" data-id="element-321" data-mp="14ceuxspiveea">
      <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-322" data-mp="zj2isi21502f">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-323" data-mp="via6ffxv2f1x">
          Inbound flow for a 9 agent team
        </p>
        <p className="text-xs text-white/30" data-id="element-324" data-mp="ql0adhfyv554">a month, demo data</p>
      </div>

      <ul className="mt-6 space-y-5" data-id="element-325" data-mp="ljawzv59ufdv">
        {stages.map((stage, index) => <li key={stage.label} data-id="element-326" data-mp="gkrbtwyi57mk" data-mpi={index}>
            <Reveal delay={0.08 * index} offset={10} data-id="element-327" data-mp="gmklll4ew7ys">
              <div className="flex items-baseline justify-between gap-4" data-id="element-328" data-mp="2u6z9gpahf1k">
                <span className="text-sm font-medium text-white/75" data-id="element-329" data-mp="2s2msadbr7po">{stage.label}</span>
                <span className="font-display text-xl font-bold text-brand" data-id="element-330" data-mp="7mqeei3mki8h">
                  <CountUp value={stage.value} data-id="element-331" data-mp="3p2gg2ol50afu" />
                </span>
              </div>
              <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-white/[0.06]" data-id="element-332" data-mp="3u100ulnzvg6m">
                <motion.div className="h-full rounded-full bg-brand" style={{
              willChange: 'transform',
              originX: 0
            }} initial={reduceMotion ? {
              scaleX: stage.fill / 100
            } : {
              scaleX: 0
            }} whileInView={{
              scaleX: stage.fill / 100
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.8,
              delay: reduceMotion ? 0 : 0.15 + index * 0.12,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-333" data-mp="llgdg3a08rzh" />
              </div>
            </Reveal>
          </li>)}
      </ul>
    </div>;
}